import dotProp from 'dot-prop-immutable'
import {
  PHOTOS_ARE_LOADING,
  PHOTOS_CHANGE_FILTER,
  PHOTOS_FAILED,
  PHOTOS_LOADED,
  SELECT_PHOTO_SIDEBAR,
  DESELECT_PHOTO_SIDEBAR,
  REMOVE_PHOTO_SIDEBAR,
} from '../constants/photosActions'
import uploadPhoto from '../repositories/uploadPhoto'
import {mapImageUrl} from "../utils/mapImageUrl";

export const loadPhotos = getPhotos => (dispatch, ownState) => {
  if (0 !== dotProp.get(ownState(), 'photos.images', []).length) {
    return
  }

  dispatch({ type: PHOTOS_ARE_LOADING })
  getPhotos()
    .then(res => dispatch({ type: PHOTOS_LOADED, images: res }))
    .catch(err => dispatch({ type: PHOTOS_FAILED, message: err.message }))
}

export const changeFilter = filter => ({ type: PHOTOS_CHANGE_FILTER, filter })

export const uploadImages = (accepted, rejected) => (dispatch, ownState) => {
  dispatch({ type: PHOTOS_ARE_LOADING })
  const currentImages = dotProp.get(ownState(), 'photos.images', [])

  Promise.all(accepted.map(file => uploadPhoto(window.fetch)(file)))
    .then(responses =>
      responses.map(({ content_url, filter }) => ({
        src: mapImageUrl(content_url),
        filter: filter,
      }))
    )
    .then(actions => {
      dispatch({ type: PHOTOS_LOADED, images: [...actions, ...currentImages] })
    })
}

export const selectPhoto = index => ({ index, type: SELECT_PHOTO_SIDEBAR })
export const deselectPhoto = () => ({ type: DESELECT_PHOTO_SIDEBAR })
export const removePhoto = index => dispatch => {
  dispatch(deselectPhoto())
  dispatch({ index, type: REMOVE_PHOTO_SIDEBAR })
}



// WEBPACK FOOTER //
// ./src/actions/photos.js